import React from "react";
import { Box, Typography } from "@mui/material";
import { menuCategories } from "../../../utils/quoteFormUtils";
import "./menuCategorySelector.scss";

interface MenuCategorySelectorProps {
	totalSections: number;
	onCategorySelect: (categoryId: string) => void;
}

const MenuCategorySelector: React.FC<MenuCategorySelectorProps> = ({ totalSections, onCategorySelect }) => {
	return (
		<Box className="menuCategorySelector">
			<Typography variant="h6" className="selectorTitle">
				Add menu category
			</Typography>

			<Box className="categoriesContainer">
				{menuCategories.map((category) => {
					const Icon = category.icon;
					return (
						<Box
							key={category.id}
							className={`categoryItem ${totalSections === 10 ? "disabled" : ""}`}
							onClick={() => totalSections !== 10 && onCategorySelect(category.id)}
						>
							<Icon />
							<Typography variant="body2" className="categoryName">
								{category.name}
							</Typography>
						</Box>
					);
				})}
			</Box>

			{totalSections === 10 && (
				<Typography className="categoriesLimitReachedText">10/10 categories added</Typography>
			)}
		</Box>
	);
};

export default MenuCategorySelector;
